import { createContext, useContext } from 'react';

export type RealtimeStatus = 'off' | 'idle' | 'connecting' | 'connected' | 'disconnected' | 'error';

export interface RealtimeContextValue {
  status: RealtimeStatus;
  isConnected: boolean;
}

export const RealtimeContext = createContext<RealtimeContextValue>({ status: 'off', isConnected: false });

export function useRealtime(): RealtimeContextValue {
  return useContext(RealtimeContext);
}
